import { useMemo } from 'react'
import { compose, hoc } from '@'
import { useForm, useFormLoading, useFormValues } from '@form'
import { withModalV4, useModal } from '@modal'
import UpdateHotel from '../../actions/UpdateHotel'
import { parseIds } from '../CoverageCommon'

const NAME = 'HotelCoverageRegionForm'

const $fieldProps = {
    region_ids: { rules: [{ required: true, whitespace: true, message: 'Please enter a region_id' }] },
    supplier_code: { rules: [{ required: true }] }
}

const container = compose(
    hoc(props => {
        const { $modal } = props

        const [$props, $form] = useForm(() => {
            const onSubmit = async values => {
                await UpdateHotel(values.hotel_id, {
                    add_regions: parseIds(values.region_ids).map(regionId => ({
                        region_id: regionId,
                        supplier_code: values.supplier_code
                    }))
                })
                $modal.close()
            }

            return {
                name: NAME,
                onSubmit,
                props: { colon: false, layout: 'vertical', wrapperCol: { flex: 1 } }
            }
        }, [$modal])

        const $loading = useFormLoading($form.name)

        $modal.setForm($form)
        $modal.setLoading($loading)

        return {
            $form,
            $props,
            $loading,
            $fieldProps,
            ...props
        }
    }),
    withModalV4(props => {
        const $values = useFormValues(NAME)

        const hotelId = useMemo(() => $values && $values.hotel_id, [$values])

        const [$props, $modal] = useModal(
            () => ({
                name: NAME,
                props: {
                    title: `Add region to hotel ${hotelId}`,
                    destroyOnClose: true,
                    okText: 'Add'
                }
            }),
            [hotelId]
        )

        return {
            $modal,
            $props,
            ...props
        }
    })
)

export default container
